<template>
	<div class="container">
		<img class="four0four" src="../assets/404.svg" />
		<div class="positionContent">
			<h2>Lost your way ?</h2>
			<p>Sorry we can't find that page</p>
			<el-button @click="backToHome()" type="text">Back To Workflows</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: "unknownRoutePage",
	methods: {
		backToHome() {
			this.$router.push("/workflows").catch(() => {
				return;
			});
		},
	},
};
</script>

<style scoped>
.container {
	height: 100vh;
}

.positionContent {
	position: absolute;
	left: 0;
	right: 0;
	margin-left: auto;
	margin-right: auto;
	width: 400px;
	top: 50%;
	padding: 20px;
}

.four0four {
	position: absolute;
	left: 0;
	right: 0;
	margin-left: auto;
	margin-right: auto;
	height: 400px;
	top: 10%;
	padding: 50px;
}
</style>
